import React from "react";
import IPage from "../../interfaces/page"
import HomeComponent from "../../components/Home/Home.component";

const HomePage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <HomeComponent></HomeComponent>;
};

export default HomePage;
